import React from 'react';
import TextField, {
  TextFieldProps,
} from '@mui/material/TextField';
import clsx from 'clsx';

type Props = TextFieldProps & {
  error?: boolean;
};

export default function FormTextField({
  className,
  error,
  ...props
}: Props) {
  return (
    <TextField
      {...props}
      error={error}
      className={clsx(
        'populate-input',
        { 'no-border': error },
        className,
      )}
    />
  );
}
